import React, { useEffect, useRef, useState } from 'react';

import './stylesBetsReport.css';

import createPrivateAdminPanelInstance from '../../../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../../../api/ApiRoutes';

import RebetLoader from '../../CommonComponents/RebetLoader/RebetLoader';

import dayjs from 'dayjs';
import { ChevronDown, ChevronUp, Filter } from 'react-feather';
import { Select, message } from 'antd';
import CustomAutoCompleteControlled from '../../CommonComponents/CustomAutoComplete/CustomAutoCompleteControlled';
import DragAndDropTable from './DragAndDropTable/DragAndDropTable';
import { DragOutlined, FullscreenOutlined } from '@ant-design/icons';
import { Popover } from 'antd';

const initialColumnsState = [
  {
    title: 'Provider',
    dataIndex: 'provider',
    key: 'provider',
    initialWidth: 150,
    columnIndex: 0,
  },
  {
    title: 'CCF',
    dataIndex: 'ccf',
    key: 'ccf',
    initialWidth: 80,
    columnIndex: 1,
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    initialWidth: 100,
    columnIndex: 2,
  },
  {
    title: 'User ID',
    dataIndex: 'userId',
    key: 'userId',
    initialWidth: 100,
    columnIndex: 3,
  },
  {
    title: 'Time',
    dataIndex: 'dateTime',
    key: 'dateTime',
    initialWidth: 150,
    columnIndex: 4,
  },
  {
    title: 'Sport',
    dataIndex: 'sport',
    key: 'sport',
    initialWidth: 100,
    columnIndex: 5,
  },
  {
    title: 'League',
    dataIndex: 'league',
    key: 'league',
    initialWidth: 150,
    columnIndex: 6,
  },
  {
    title: 'Market',
    dataIndex: 'market',
    key: 'market',
    initialWidth: 200,
    columnIndex: 7,
  },
  {
    title: 'Selection',
    dataIndex: 'selection',
    key: 'selection',
    initialWidth: 200,
    columnIndex: 8,
  },
  {
    title: 'Odds',
    dataIndex: 'odds',
    key: 'odds',
    initialWidth: 200,
    columnIndex: 9,
  },
  {
    title: 'Bet Type',
    dataIndex: 'betType',
    key: 'betType',
    initialWidth: 200,
    columnIndex: 10,
  },
  {
    title: 'Live',
    dataIndex: 'preMatchLive',
    key: 'preMatchLive',
    initialWidth: 200,
    columnIndex: 11,
  },
  {
    title: 'Bet Amount',
    dataIndex: 'wagerAmount',
    key: 'wagerAmount',
    initialWidth: 200,
    columnIndex: 12,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    initialWidth: 200,
    columnIndex: 13,
  },
  {
    title: 'Potential Payout',
    dataIndex: 'payout',
    key: 'payout',
    initialWidth: 200,
    columnIndex: 14,
  },
];

function BetsReport({ activeTab, setActiveTab }) {
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    false
  );
  const columnsState =
    JSON.parse(localStorage.getItem('columnsState')) || initialColumnsState;
  const todayRange = [dayjs(), dayjs()];
  const filtersRef = useRef({});

  const [messageApi, contextHolder] = message.useMessage();

  const [isApiRunning, setIsApiRunning] = useState(false);
  const [showExtraFilters, setShowExtraFilters] = useState(false);

  const [filtersApplied, setFiltersApplied] = useState(false);
  const filtersAppliedRef = useRef(filtersApplied);

  const [selectedSports, setSelectedSports] = useState(null);
  const [selectedLeagues, setSelectedLeagues] = useState(null);
  const [selectedOddProvider, setSelectedOddProvider] = useState(null);
  const [selectedMinBetAmount, setSelectedMinBetAmount] = useState(null);
  const [selectedBetType, setSelectedBetType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [selectedMarketType, setSelectedMarketType] = useState(null);
  const [selectedMinCCF, setSelectedMinCCF] = useState(null);
  const [selectedMaxCCF, setSelectedMaxCCF] = useState(null);
  const [selectedPreMatchLive, setSelectedPreMatchLive] = useState(null);
  const [selectedMoneyType, setSelectedMoneyType] = useState(null);

  const [scrolledDown, setScrolledDown] = useState(false);
  const [runWebSocket, setRunWebSocket] = useState(false);

  const columns = columnsState;

  const [modeState, setModeState] = useState('resize');

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [sports, setSports] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [matches, setMatches] = useState([]);
  const [marketTypes, setMarketTypes] = useState([
    {
      value: 'moneyline',
      label: 'Moneyline',
    },
    {
      value: 'spread',
      label: 'Spread',
    },
    {
      value: 'total',
      label: 'Total',
    },
  ]);
  const [minCCF, setMinCCF] = useState([]);
  const [maxCCF, setMaxCCF] = useState([]);
  const [statuses, setStatuses] = useState([
    {
      value: 'Accepted',
      label: 'Accepted',
    },
    {
      value: 'Rejected',
      label: 'Rejected',
    },
  ]);
  const [oddsProviders, setOddsProviders] = useState([]);
  const preMatchLive = [
    {
      value: 'live',
      label: 'Live',
    },
    {
      value: 'prematch',
      label: 'Pre-match',
    },
    {
      value: '500',
      label: '500 - 600',
    },
  ];

  const betTypes = [
    {
      value: 'Straight',
      label: 'Straight',
    },
    {
      value: 'Parlay',
      label: 'Parlay',
    },
    {
      value: 'Round Robin',
      label: 'Round Robin',
    },
    {
      value: 'Grouped',
      label: 'Grouped',
    },
  ];
  const moneyTypes = [
    {
      value: null,
      label: 'All',
    },
    {
      value: 'rebet_cash',
      label: 'Cash',
    },
    {
      value: 'rebet_coin',
      label: 'Coin',
    },
    {
      value: 'rebet_free_cash',
      label: 'Free Cash',
    },
  ];

  const [betsToShowInTable, setBetsToShowInTable] = useState([]);
  //   const [betsToShowInTable, setBetsToShowInTable] = useState([
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "181a3291-e8ea-47a5-997f-3836d3b38c85",
  //         "userId": "1fa383a0-7370-4dbf-a129-b680b205faae",
  //         "dateTime": "2025-08-07 12:58:38",
  //         "betType": "Parlay",
  //         "status": "Accepted",
  //         "eventId": "sr:match:60575531",
  //         "tableSource": "groupedBets",
  //         "money_type": "rebet_free_cash",
  //         "ccf": 1,
  //         "user_metadata": {
  //             "total_wagers": 3121.16,
  //             "total_payouts": 2276.85,
  //             "net_pnl": -844.31,
  //             "margin_percentage": 27.05,
  //             "total_bets_count": 925
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "American Football",
  //             "Basketball",
  //             "Tennis"
  //         ],
  //         "league": [
  //             "WTA Montreal",
  //             "Canada Women Singles",
  //             "WNBA",
  //             "NFL Preseason",
  //             "ATP Cincinnati",
  //             "USA Men Singles"
  //         ],
  //         "market": [
  //             "Winner (incl. overtime)",
  //             "Winner (incl. overtime)",
  //             "Winner",
  //             "Winner",
  //             "Winner",
  //             "{$competitor2} to win a set",
  //             "Set handicap",
  //             "Winner",
  //             "{$competitor1} to win a set",
  //             "{$competitor2} to win a set",
  //             "Winner (incl. overtime)"
  //         ],
  //         "market_ids": "192, 193, 188, 219, 186",
  //         "selection": [
  //             "Seattle Seahawks",
  //             "Baltimore Ravens",
  //             "Osaka, Naomi",
  //             "Wong, Coleman",
  //             "Safiullin, Roman",
  //             "yes",
  //             "Nishioka, Yoshihito (-1.5)",
  //             "Marozsan, Fabian",
  //             "yes",
  //             "yes",
  //             "Phoenix Mercury"
  //         ],
  //         "specifiers": "hcp=1.5",
  //         "odds": 98706,
  //         "wagerAmount": 0.7,
  //         "payout": 691.64,
  //         "customId": 13
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "4e3f5a52-88c2-4fa5-ba99-65c839143702",
  //         "userId": "78155c0c-bcb9-484e-b929-3c65f74b3a85",
  //         "dateTime": "2025-08-07 12:58:38",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:55312245",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_free_cash",
  //         "ccf": null,
  //         "user_metadata": {
  //             "total_wagers": 0,
  //             "total_payouts": 0,
  //             "net_pnl": 0,
  //             "margin_percentage": 0,
  //             "total_bets_count": 0
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "Baseball"
  //         ],
  //         "league": [
  //             "MLB"
  //         ],
  //         "market": [
  //             "Winner (incl. extra innings)"
  //         ],
  //         "selection": [
  //             "San Francisco Giants"
  //         ],
  //         "odds": -155,
  //         "wagerAmount": 1.16,
  //         "payout": 1.91,
  //         "customId": 12
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "9b1b0002-1197-4d2c-be19-aad1b87ce643",
  //         "userId": "88774f35-e0c4-4a4f-a255-7cfe504fef4f",
  //         "dateTime": "2025-08-07 12:58:38",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:55312245",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_coin",
  //         "ccf": 1,
  //         "user_metadata": {
  //             "total_wagers": 38.9,
  //             "total_payouts": 0.96,
  //             "net_pnl": -37.94,
  //             "margin_percentage": 97.53,
  //             "total_bets_count": 10
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "Baseball"
  //         ],
  //         "league": [
  //             "MLB"
  //         ],
  //         "market": [
  //             "Batter hits (incl. extra innings)"
  //         ],
  //         "selection": [
  //             "Knizner, Andrew 2+"
  //         ],
  //         "odds": 490,
  //         "wagerAmount": 100,
  //         "payout": 590,
  //         "customId": 11
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "668bc541-bcbf-4679-9404-a77fa8d639fb",
  //         "userId": "60932250-f272-4e9b-89cc-1b325aa01a09",
  //         "dateTime": "2025-08-07 12:58:37",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:62456340",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 1.11,
  //         "user_metadata": {
  //             "total_wagers": 18126.08,
  //             "total_payouts": 9182.96,
  //             "net_pnl": -8943.12,
  //             "margin_percentage": 49.34,
  //             "total_bets_count": 2547
  //         },
  //         "preMatchLive": "live",
  //         "sport": [
  //             "Tennis"
  //         ],
  //         "league": [
  //             "ATP Challenger Grodzisk Mazowiecki",
  //             "Poland Men Singles"
  //         ],
  //         "market": [
  //             "{!setnr} set - total games"
  //         ],
  //         "selection": [
  //             ""
  //         ],
  //         "odds": 359,
  //         "wagerAmount": 6.79,
  //         "payout": 31.17,
  //         "customId": 10
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "3e3b19d5-78e9-4d56-ae0c-6480ac14c4fd",
  //         "userId": "f03c92bf-ce8d-48f9-858e-149635330a24",
  //         "dateTime": "2025-08-07 12:58:37",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:62641461",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 0.1,
  //         "user_metadata": {
  //             "total_wagers": 2282.89,
  //             "total_payouts": 1844.29,
  //             "net_pnl": -438.6,
  //             "margin_percentage": 19.21,
  //             "total_bets_count": 116
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             ""
  //         ],
  //         "league": [
  //             "ATP Cincinnati",
  //             "USA Men Singles"
  //         ],
  //         "market": [
  //             "Game handicap"
  //         ],
  //         "selection": [
  //             "Boyer, Tristan (+1.5)"
  //         ],
  //         "odds": -111,
  //         "wagerAmount": 6.3,
  //         "payout": 11.98,
  //         "customId": 9
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "0a80d2e9-d26b-4e47-9150-dd24ffbdbf52",
  //         "userId": "37e3b0d7-942c-4fda-bb9e-c7ff592581a8",
  //         "dateTime": "2025-08-07 12:58:36",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:55310695",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 1,
  //         "user_metadata": {
  //             "total_wagers": 763.7,
  //             "total_payouts": 690.26,
  //             "net_pnl": -73.44,
  //             "margin_percentage": 9.62,
  //             "total_bets_count": 262
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "Baseball"
  //         ],
  //         "league": [
  //             "MLB"
  //         ],
  //         "market": [
  //             "Winner (incl. extra innings)"
  //         ],
  //         "selection": [
  //             "Minnesota Twins"
  //         ],
  //         "odds": 170,
  //         "wagerAmount": 3,
  //         "payout": 8.1,
  //         "customId": 8
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "96de161e-f1f7-4268-b7da-abe483b29070",
  //         "userId": "f2fce732-4312-4ba4-b914-f59d64e4decb",
  //         "dateTime": "2025-08-07 12:58:35",
  //         "betType": "Parlay",
  //         "status": "Accepted",
  //         "eventId": "sr:match:56328267",
  //         "tableSource": "groupedBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 0.94,
  //         "user_metadata": {
  //             "total_wagers": 1434.25,
  //             "total_payouts": 1202.12,
  //             "net_pnl": -232.13,
  //             "margin_percentage": 16.18,
  //             "total_bets_count": 250
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "American Football",
  //             "Basketball",
  //             "Baseball"
  //         ],
  //         "league": [
  //             "WNBA",
  //             "NFL Preseason",
  //             "MLB"
  //         ],
  //         "market": [
  //             "Player points (incl. overtime)",
  //             "Player points (incl. overtime)",
  //             "Winner (incl. overtime)",
  //             "Winner (incl. overtime)",
  //             "Winner (incl. overtime)",
  //             "Pitcher strikeouts (incl. extra innings)",
  //             "Batter hits (incl. extra innings)"
  //         ],
  //         "market_ids": "219, 768, 781, 785",
  //         "selection": [
  //             "Cardoso, Kamilla 13+",
  //             "Boston, Aliyah 16+",
  //             "Indianapolis Colts",
  //             "Philadelphia Eagles",
  //             "Seattle Seahawks",
  //             "Skenes, Paul 7+",
  //             "Harris II, Michael 1+"
  //         ],
  //         "specifiers": "variant=pre:playerprops:56328267:2106396 | variant=pre:playerprops:56328271:2272927 | variant=pre:playerprops:55309045:2566049 | variant=pre:playerprops:55307931:2010889",
  //         "odds": 6397,
  //         "wagerAmount": 1,
  //         "payout": 64.97,
  //         "customId": 7
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "a4778641-d58d-44be-ab1e-2e24504cbb97",
  //         "userId": "048fa0e1-6f10-46c0-a977-9e45f7dfa6c1",
  //         "dateTime": "2025-08-07 12:58:33",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:60575531",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 1,
  //         "user_metadata": {
  //             "total_wagers": 254.77,
  //             "total_payouts": 205.02,
  //             "net_pnl": -49.75,
  //             "margin_percentage": 19.53,
  //             "total_bets_count": 240
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "American Football"
  //         ],
  //         "league": [
  //             "NFL Preseason"
  //         ],
  //         "market": [
  //             "Winner (incl. overtime)"
  //         ],
  //         "selection": [
  //             "Seattle Seahawks"
  //         ],
  //         "odds": 185,
  //         "wagerAmount": 1,
  //         "payout": 2.85,
  //         "customId": 6
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "40b1bc94-d07e-4e75-9184-66823fd1caee",
  //         "userId": "b95ef1ae-b734-408c-b4af-c66edfe31828",
  //         "dateTime": "2025-08-07 12:58:31",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:62629089",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 1.19,
  //         "user_metadata": {
  //             "total_wagers": 158882.18,
  //             "total_payouts": 107389.05,
  //             "net_pnl": -51493.13,
  //             "margin_percentage": 32.41,
  //             "total_bets_count": 3376
  //         },
  //         "preMatchLive": "live",
  //         "sport": [
  //             "Table Tennis"
  //         ],
  //         "league": [
  //             "TT Elite Series"
  //         ],
  //         "market": [
  //             "Point handicap"
  //         ],
  //         "selection": [
  //             "Jurowicz, Grzegorz (+2.5)"
  //         ],
  //         "odds": 220,
  //         "wagerAmount": 9,
  //         "payout": 28.8,
  //         "customId": 5
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "2464eac3-b46d-4e47-bd4f-4ba7ba2418ba",
  //         "userId": "a59bd8a5-98a8-4752-a966-5f2dae343012",
  //         "dateTime": "2025-08-07 12:58:30",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:62641481",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 1,
  //         "user_metadata": {
  //             "total_wagers": 1887.6,
  //             "total_payouts": 1390.89,
  //             "net_pnl": -496.71,
  //             "margin_percentage": 26.31,
  //             "total_bets_count": 749
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "Tennis"
  //         ],
  //         "league": [
  //             "ATP Cincinnati",
  //             "USA Men Singles"
  //         ],
  //         "market": [
  //             "Total games"
  //         ],
  //         "selection": [
  //             "over 22.5"
  //         ],
  //         "odds": -129,
  //         "wagerAmount": 0.5,
  //         "payout": 0.89,
  //         "customId": 4
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "dst",
  //         "id": "350950248",
  //         "userId": "e5064b51-5503-4ebd-8340-2dc180f8aa6d",
  //         "dateTime": "2025-08-07 12:58:28",
  //         "betType": "Parlay",
  //         "status": "Accepted",
  //         "eventId": "sr:match:55311779",
  //         "tableSource": "groupedBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 1,
  //         "user_metadata": {
  //             "total_wagers": 322.39,
  //             "total_payouts": 240.81,
  //             "net_pnl": -81.58,
  //             "margin_percentage": 25.31,
  //             "total_bets_count": 132
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "Baseball"
  //         ],
  //         "league": [
  //             "MLB"
  //         ],
  //         "market": [
  //             "7+ strikeouts",
  //             "7+ strikeouts",
  //             "to win",
  //             "1st inning result",
  //             "total runs"
  //         ],
  //         "market_ids": "7+ strikeouts, total runs, to win, 1st inning result",
  //         "selection": [
  //             "logan gilbert",
  //             "paul skenes",
  //             "SEA",
  //             "DRAW",
  //             "Over (6.5)"
  //         ],
  //         "specifiers": "player",
  //         "odds": 363,
  //         "wagerAmount": 5,
  //         "payout": 23.15,
  //         "customId": 3
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "ecba5eee-e13b-4b66-ab84-41031f736b14",
  //         "userId": "7027a939-866a-4cce-9f8e-d6cd55a2603b",
  //         "dateTime": "2025-08-07 12:58:28",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:60575449",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_coin",
  //         "ccf": null,
  //         "user_metadata": {
  //             "total_wagers": 2.18,
  //             "total_payouts": 2.74,
  //             "net_pnl": 0.56,
  //             "margin_percentage": -25.83,
  //             "total_bets_count": 2
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "American Football"
  //         ],
  //         "league": [
  //             "NFL Preseason"
  //         ],
  //         "market": [
  //             "Total (incl. overtime)"
  //         ],
  //         "selection": [
  //             "over 37.5"
  //         ],
  //         "odds": -108,
  //         "wagerAmount": 300,
  //         "payout": 577.78,
  //         "customId": 2
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "ae212d67-9f1e-4b3b-92f0-92ec1b3cf4a8",
  //         "userId": "722c2988-7b55-43c3-906e-418bda0401dd",
  //         "dateTime": "2025-08-07 12:58:28",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:simple_tournament:158533",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 1,
  //         "user_metadata": {
  //             "total_wagers": 50,
  //             "total_payouts": 0,
  //             "net_pnl": -50,
  //             "margin_percentage": 100,
  //             "total_bets_count": 50
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "Golf"
  //         ],
  //         "league": [
  //             "Presidents Cup 2026"
  //         ],
  //         "market": [
  //             "Presidents Cup - Winner"
  //         ],
  //         "selection": [
  //             "USA"
  //         ],
  //         "odds": -409,
  //         "wagerAmount": 1,
  //         "payout": 1.24,
  //         "customId": 1
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "3b8d2ff7-3b97-4f50-b9f3-172e1c5630f1",
  //         "userId": "829f4331-86df-4413-a60e-a0e45de63de7",
  //         "dateTime": "2025-08-07 12:58:28",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:62617448",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 1,
  //         "user_metadata": {
  //             "total_wagers": 7222.31,
  //             "total_payouts": 3575.29,
  //             "net_pnl": -3647.02,
  //             "margin_percentage": 50.5,
  //             "total_bets_count": 310
  //         },
  //         "preMatchLive": "live",
  //         "sport": [
  //             "Basketball"
  //         ],
  //         "league": [
  //             "U20 EuroBasket",
  //             "Div. A",
  //             "Women"
  //         ],
  //         "market": [
  //             "Handicap (incl. overtime)"
  //         ],
  //         "selection": [
  //             "Israel (-4.5)"
  //         ],
  //         "odds": -133,
  //         "wagerAmount": 42,
  //         "payout": 73.58,
  //         "customId": 0
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "86915b2b-5b20-4503-93b9-6d0271f39aeb",
  //         "userId": "a27c633a-d6af-46ab-b84f-18bd47ef8868",
  //         "dateTime": "2025-08-07 12:55:15",
  //         "betType": "Straight",
  //         "status": "Accepted",
  //         "eventId": "sr:match:55308487",
  //         "tableSource": "sportsbookBets",
  //         "money_type": "rebet_cash",
  //         "ccf": 1.4,
  //         "user_metadata": {
  //             "total_wagers": 26220.48,
  //             "total_payouts": 9207.44,
  //             "net_pnl": -17013.04,
  //             "margin_percentage": 64.88,
  //             "total_bets_count": 278
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "Baseball"
  //         ],
  //         "league": [
  //             "MLB"
  //         ],
  //         "market": [
  //             "Batter home runs (incl. extra innings)"
  //         ],
  //         "selection": [
  //             "Rutschman, Adley 1+"
  //         ],
  //         "odds": 600,
  //         "wagerAmount": 50,
  //         "payout": 350,
  //         "customId": 12
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "f3dee0d4-25bc-4eea-a327-21dbf568583b",
  //         "userId": "d43d1875-9e69-4a62-8433-3fad806df3af",
  //         "dateTime": "2025-08-07 09:59:35",
  //         "betType": "Parlay",
  //         "status": "Accepted",
  //         "eventId": "sr:match:55311779",
  //         "tableSource": "groupedBets",
  //         "money_type": "rebet_free_cash",
  //         "ccf": null,
  //         "user_metadata": {
  //             "total_wagers": 0,
  //             "total_payouts": 0,
  //             "net_pnl": 0,
  //             "margin_percentage": 0,
  //             "total_bets_count": 0
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "Baseball",
  //             "Basketball"
  //         ],
  //         "league": [
  //             "MLB",
  //             "WNBA"
  //         ],
  //         "market": [
  //             "Handicap (incl. extra innings)",
  //             "Handicap (incl. extra innings)",
  //             "Handicap (incl. extra innings)",
  //             "Winner (incl. overtime)",
  //             "Winner (incl. overtime)",
  //             "Winner (incl. overtime)",
  //             "Winner (incl. overtime)",
  //             "Winner (incl. overtime)",
  //             "Winner (incl. overtime)"
  //         ],
  //         "market_ids": "256, 219",
  //         "selection": [
  //             "Chicago White Sox (+2.0)",
  //             "Pittsburgh Pirates (-1.0)",
  //             "Atlanta Braves (+1.0)",
  //             "Atlanta Dream",
  //             "Los Angeles Sparks",
  //             "Phoenix Mercury",
  //             "New York Liberty",
  //             "Minnesota Lynx",
  //             "Las Vegas Aces"
  //         ],
  //         "specifiers": "hcp=-1 | hcp=-2 | hcp=1",
  //         "odds": 3108,
  //         "wagerAmount": 3.46,
  //         "payout": 111,
  //         "customId": 60
  //     },
  //     {
  //         "type": "newBet",
  //         "provider": "sportradar",
  //         "id": "f3dee0d4-25bc-4eea-a327-21dbf568583b",
  //         "userId": "d43d1875-9e69-4a62-8433-3fad806df3af",
  //         "dateTime": "2025-08-07 09:59:35",
  //         "betType": "Parlay",
  //         "status": "Accepted",
  //         "eventId": "sr:match:55311779",
  //         "tableSource": "groupedBets",
  //         "money_type": "rebet_free_cash",
  //         "ccf": null,
  //         "user_metadata": {
  //             "total_wagers": 0,
  //             "total_payouts": 0,
  //             "net_pnl": 0,
  //             "margin_percentage": 0,
  //             "total_bets_count": 0
  //         },
  //         "preMatchLive": "prematch",
  //         "sport": [
  //             "Baseball"
  //         ],
  //         "league": [
  //             "MLB",
  //             "WNBA"
  //         ],
  //         "market": [
  //             "Handicap (incl. extra innings)"
  //         ],
  //         "market_ids": "256, 219",
  //         "selection": [
  //             "Chicago White Sox (+2.0)"
  //         ],
  //         "specifiers": "hcp=-1 | hcp=-2 | hcp=1",
  //         "odds": 3108,
  //         "wagerAmount": 3.46,
  //         "payout": 111,
  //         "customId": 60
  //     }
  // ]);
  const [pendingBets, setPendingBets] = useState([]);

  const [filterType, setFilterType] = useState('all');
  const tableRef = useRef(null);
  const isAtTop = useRef(true);

  const getBetsReport = async (queryString = todayRange) => {
    let startDate = '';
    let endDate = '';

    startDate = queryString[0]?.format('YYYY-MM-DD');
    endDate = queryString[1]?.format('YYYY-MM-DD');

    const params = {
      start_date: startDate,
      end_date: endDate,
    };

    try {
      setIsApiRunning(true);

      const requests = [
        PrivateAdminPanelInstance?.post(
          API_ROUTES?.GET_SPORTSBOOK_OVERVIEW,
          params
        ),
        PrivateAdminPanelInstance?.post(
          API_ROUTES?.GET_POPULAR_MARKETS,
          params
        ),
      ];
      const responses = await Promise.allSettled(requests);

      const [sportsbookOverviewResponse, popularMarketsResponse] = responses;

      if (sportsbookOverviewResponse.status === 'fulfilled') {
        const data = sportsbookOverviewResponse?.value?.data?.data;

        const leagues = data.league_names.map((league) => {
          return {
            value: league,
            label: league,
          };
        });

        const sports = data.sport_names.map((sport) => {
          return {
            value: sport,
            label: sport,
          };
        });

        const odds_providers = data.odds_providers.map((odds_provider) => {
          return {
            value: odds_provider,
            label: odds_provider,
          };
        });
        const matches = data.event_ids.map((event_id) => {
          return {
            value: event_id,
            label: event_id,
          };
        });
        setLeagues(leagues);
        setSports(sports);
        setOddsProviders(odds_providers);
        setMatches(matches);
      }

      if (popularMarketsResponse.status === 'fulfilled') {
        const data = popularMarketsResponse?.value?.data?.data?.data;
        const marketTypes = data.map((market) => {
          return {
            value: market.market_name,
            label: market.market_name,
          };
        });
        setMarketTypes((prev) => [...prev, ...marketTypes]);
      }
      setRunWebSocket(true);
    } catch (error) {
      console.log('Error adding event code:', error);
    } finally {
      setIsApiRunning(false);
    }
  };

  const handleBetTypeChange = (value) => {
    setSelectedBetType(value);
  };

  const handleBetAmountChange = (value) => {
    setSelectedMinBetAmount(value);
  };

  const handleLeagueChange = (value) => {
    setSelectedLeagues(value);
  };

  const handleOddProviderChange = (value) => {
    setSelectedOddProvider(value);
  };

  const handleSportChange = (value) => {
    setSelectedSports(value);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const handlePreMatchLiveChange = (value) => {
    setSelectedPreMatchLive(value);
  };

  const handleMatchChange = (value) => {
    setSelectedMatch(value);
  };

  const handleMarketTypeChange = (value) => {
    setSelectedMarketType(value);
  };

  const handleMinCCFChange = (value) => {
    setSelectedMinCCF(value);
  };

  const handleMaxCCFChange = (value) => {
    setSelectedMaxCCF(value);
  };

  const handleMoneyTypeChange = (value) => {
    setSelectedMoneyType(value);
  };

  const handleClearFilters = () => {
    setSelectedSports(null);
    setSelectedBetType(null);
    setSelectedMinBetAmount(null);
    setSelectedLeagues(null);
    setSelectedOddProvider(null);
    setSelectedStatus(null);
    setSelectedPreMatchLive(null);
    setSelectedMatch(null);
    setSelectedMarketType(null);
    setSelectedMinCCF(null);
    setSelectedMaxCCF(null);
    setSelectedMoneyType(null);
    setFiltersApplied(false);
    message.success('Filters cleared.');
  };

  const handleApplyFilters = () => {
    setFiltersApplied(true);
    message.success('Filters applied.');
  };

  useEffect(() => {
    getBetsReport();
  }, []);

  const shouldIncludeData = (data) => {
    const {
      selectedSports,
      selectedLeagues,
      selectedMatch,
      selectedMinBetAmount,
      selectedBetType,
      selectedMarketType,
      selectedMinCCF,
      selectedMaxCCF,
      selectedOddProvider,
      selectedStatus,
      selectedPreMatchLive,
      selectedMoneyType,
    } = filtersRef.current;

    if (selectedSports && !selectedSports.includes(data.sport)) return false;

    if (selectedLeagues) {
      const selectedLeaguesArray = selectedLeagues
        .split(',')
        .map((s) => s.trim());
      if (
        !selectedLeaguesArray.some((league) => data.league?.includes(league))
      ) {
        return false;
      }
    }

    if (selectedMatch && !selectedMatch.includes(data.eventId)) return false;

    if (
      selectedMinBetAmount !== null &&
      data.wagerAmount <= selectedMinBetAmount
    )
      return false;

    if (selectedBetType && data.betType !== selectedBetType) return false;

    if (
      selectedMarketType &&
      !data.market?.toLowerCase().includes(selectedMarketType.toLowerCase())
    )
      return false;

    if (selectedMinCCF !== null && data.ccf <= selectedMinCCF) return false;

    if (selectedMaxCCF !== null && data.ccf >= selectedMaxCCF) return false;

    if (selectedOddProvider) {
      const selectedOddProviderArray = selectedOddProvider
        .split(',')
        .map((s) => s.trim());
      if (
        !selectedOddProviderArray.some((provider) =>
          data.provider?.includes(provider)
        )
      ) {
        return false;
      }
    }

    if (selectedStatus && data.status !== selectedStatus) return false;

    if (
      selectedPreMatchLive !== null &&
      data.preMatchLive !== selectedPreMatchLive
    )
      return false;

    if (selectedMoneyType && data.money_type !== selectedMoneyType)
      return false;

    return true;
  };

  const wsRef = useRef(null);
  const filterTypeRef = useRef(filterType);

  const messageBuffer = useRef([]);
  const flushTimer = useRef(null);
  let uniqueIdCounter = 0;

  const flushBuffer = () => {
    if (messageBuffer.current.length === 0) return;

    const bufferedMessages = [...messageBuffer.current];
    messageBuffer.current = [];

    bufferedMessages.forEach((rawData, index) => {
      try {
        const data = JSON.parse(rawData);

        const {
          selectedSports,
          selectedLeagues,
          selectedMatch,
          selectedMinBetAmount,
          selectedBetType,
          selectedMarketType,
          selectedMinCCF,
          selectedMaxCCF,
          selectedOddProvider,
          selectedStatus,
          selectedPreMatchLive,
          selectedMoneyType,
        } = filtersRef.current || {};

        if (filtersAppliedRef.current && !shouldIncludeData(data)) return;

        let filteredData = data;
        if (filterTypeRef.current !== 'all') {
          filteredData =
            filteredData.money_type === filterTypeRef.current
              ? filteredData
              : null;
        }
        if (!filteredData) return;
        filteredData.customId = uniqueIdCounter++;

        const sports = filteredData.sport.split(',').map((s) => s.trim());
        const leagues = filteredData.league.split(',').map((s) => s.trim());
        const markets = filteredData.market.split(' + ').map((s) => s.trim());
        const selections = filteredData.selection
          .split(' + ')
          .map((s) => s.trim());

        filteredData.dateTime = filteredData.dateTime.split(' ')[1];
        filteredData.sport = sports;
        filteredData.league = leagues;
        filteredData.market = markets;
        filteredData.selection = selections;

        const transformedData = filteredData;
        const setter = isAtTop.current ? setBetsToShowInTable : setPendingBets;
        setter((prev) => {
          const newData = [transformedData, ...prev];
          return newData.slice(0, 50);
        });
      } catch (e) {
        console.error('❌ Erro ao processar mensagem WS:', e);
      }
    });
  };

  useEffect(() => {
    filterTypeRef.current = filterType;
  }, [filterType]);

  useEffect(() => {
    filtersAppliedRef.current = filtersApplied;
  }, [filtersApplied]);

  useEffect(() => {
    if (!runWebSocket) return;

    const ws = new WebSocket(
      'wss://vz8gzvx9dc.execute-api.us-east-2.amazonaws.com/prod'
    );
    wsRef.current = ws;

    flushTimer.current = setInterval(flushBuffer, 2000);

    ws.onopen = () => {
      console.log('WebSocket connection opened');
    };

    ws.onmessage = (message) => {
      console.log(message.data);
      messageBuffer.current.push(message.data);
    };

    ws.onclose = () => {
      console.log('WebSocket connection closed');
    };

    ws.onerror = (err) => {
      console.error('Erro WebSocket:', err);
    };

    return () => {
      if (ws.readyState < 2) {
        ws.close();
      }
      clearInterval(flushTimer.current);
    };
  }, [runWebSocket]);

  useEffect(() => {
    const checkScroll = () => {
      const scrollContainer = tableRef.current?.querySelector(
        '.drag-and-drop-table-container'
      );
      if (!scrollContainer) return;

      const atTop = scrollContainer.scrollTop === 0;
      isAtTop.current = atTop;
      setScrolledDown(!atTop);

      if (atTop && pendingBets.length > 0) {
        setBetsToShowInTable((prev) => {
          const combined = [...pendingBets, ...prev];
          return combined.slice(0, 100);
        });
        setPendingBets([]);
      }
    };

    const interval = setInterval(() => {
      const scrollContainer = tableRef.current?.querySelector(
        '.drag-and-drop-table-container'
      );
      if (scrollContainer && !scrollContainer.dataset.listenerAttached) {
        scrollContainer.dataset.listenerAttached = 'true';
        scrollContainer.addEventListener('scroll', checkScroll);
        checkScroll();
      }
    }, 100);

    return () => clearInterval(interval);
  }, [pendingBets]);

  useEffect(() => {
    filtersRef.current = {
      selectedSports,
      selectedLeagues,
      selectedMatch,
      selectedMinBetAmount,
      selectedBetType,
      selectedMarketType,
      selectedMinCCF,
      selectedMaxCCF,
      selectedOddProvider,
      selectedStatus,
      selectedPreMatchLive,
      selectedMoneyType,
    };
  }, [
    selectedSports,
    selectedLeagues,
    selectedMatch,
    selectedMinBetAmount,
    selectedBetType,
    selectedMarketType,
    selectedMinCCF,
    selectedMaxCCF,
    selectedOddProvider,
    selectedStatus,
    selectedPreMatchLive,
    selectedMoneyType,
  ]);

  return (
    <div className="betsReport-container">
      <div className="betsReport">
        {contextHolder}
        <>
          <div className="head-controls">
            <div className="header-text-container">
              <p className="header-text">Sportsbook</p>
            </div>
          </div>

          <div className="betsReport-content">
            <div className="betsReport-content-header">
              <div className="sportsbook-tabs">
                <button
                  className={activeTab === 'Sportsbook KPI' ? 'active' : null}
                  onClick={() => setActiveTab('Sportsbook Kpi')}
                >
                  Sportsbook KPI
                </button>
                <button
                  className={activeTab === 'Events List' ? 'active' : null}
                  onClick={() => setActiveTab('Events List')}
                >
                  Events List
                </button>
                <button
                  className={activeTab === 'Latest Bets List' ? 'active' : null}
                  onClick={() => setActiveTab('Latest Bets List')}
                >
                  Latest Bets List
                </button>
              </div>
              <div className="betsReport-autocomplete-container">
                <div
                  className="filter-buttons"
                  onClick={() => setShowExtraFilters(!showExtraFilters)}
                >
                  <Filter className="filter-icon" />
                  {showExtraFilters ? (
                    <ChevronUp className="filter-icon" />
                  ) : (
                    <ChevronDown className="filter-icon" />
                  )}
                </div>
              </div>
            </div>
            <div
              className="betsReport-selectors"
              style={{ display: showExtraFilters ? 'flex' : 'none' }}
            >
              <div className="betsReport-selector">
                <span>Sport</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedSports}
                  handleChange={(value) => handleSportChange(value)}
                  allOptions={sports}
                  clearOptions={() => handleSportChange(null)}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector">
                <span>League</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedLeagues}
                  handleChange={(value) => handleLeagueChange(value)}
                  allOptions={leagues}
                  clearOptions={() => handleLeagueChange(null)}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector">
                <span>Match</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMatch}
                  handleChange={(value) => handleMatchChange(value)}
                  allOptions={matches}
                  clearOptions={() => handleMatchChange(null)}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector">
                <span>Min Bet Amount</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMinBetAmount}
                  handleChange={(value) => handleBetAmountChange(value)}
                  allOptions={[]}
                  clearOptions={() => handleBetAmountChange(null)}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector">
                <span>Bet Type</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedBetType}
                  onChange={(value) => handleBetTypeChange(value)}
                  options={betTypes}
                />
              </div>
              <div className="betsReport-selector">
                <span>Market Type</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMarketType}
                  handleChange={(value) => handleMarketTypeChange(value)}
                  allOptions={marketTypes}
                  clearOptions={() => handleMarketTypeChange(null)}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector">
                <span>Min CCF</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMinCCF}
                  handleChange={(value) => handleMinCCFChange(value)}
                  clearOptions={() => handleMinCCFChange(null)}
                  allOptions={minCCF}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector">
                <span>Max CCF</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMaxCCF}
                  handleChange={(value) => handleMaxCCFChange(value)}
                  clearOptions={() => handleMaxCCFChange(null)}
                  allOptions={maxCCF}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector">
                <span>Odds Provider</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedOddProvider}
                  onChange={(value) => handleOddProviderChange(value)}
                  options={oddsProviders}
                />
              </div>
              <div className="betsReport-selector">
                <span>Status</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedStatus}
                  onChange={(value) => handleStatusChange(value)}
                  options={statuses}
                />
              </div>
              <div className="betsReport-selector">
                <span>Pre-match/Live</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedPreMatchLive}
                  onChange={(value) => handlePreMatchLiveChange(value)}
                  options={preMatchLive}
                />
              </div>
              <div className="betsReport-selector">
                <span>Money Type</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedMoneyType}
                  onChange={(value) => handleMoneyTypeChange(value)}
                  options={moneyTypes}
                />
              </div>
            </div>

            {showExtraFilters && (
              <div className="drag-resize-buttons-container">
                <Popover content="Resize Mode">
                  <button
                    className={modeState === 'resize' ? 'active' : null}
                    onClick={() => setModeState('resize')}
                  >
                    <FullscreenOutlined />
                  </button>
                </Popover>
                <Popover content="Drag Mode">
                  <button
                    className={modeState === 'drag' ? 'active' : null}
                    onClick={() => setModeState('drag')}
                  >
                    <DragOutlined />
                  </button>
                </Popover>
              </div>
            )}
            {showExtraFilters && (
              <div className="betsReport-selector-action-buttons">
                <button className="clear" onClick={() => handleClearFilters()}>
                  Clear Filters
                </button>
                <button className="apply" onClick={() => handleApplyFilters()}>
                  Apply
                </button>
              </div>
            )}
            {isApiRunning ? (
              <RebetLoader height={'100px'} width={'100px'} />
            ) : (
              <div className="betsReport-kpis-table" ref={tableRef}>
                <DragAndDropTable
                  columns={columns}
                  data={betsToShowInTable}
                  mode={modeState}
                />
              </div>
            )}
          </div>
        </>
      </div>
    </div>
  );
}

export default BetsReport;
